/* Variant-Badges auf der Produktseite: Kacheln beim Sortenwechsel aus data-badge-map umschalten.
   Kein Auslesen des Pickers; die Daten stehen in snippets/variant-badge-tiles.liquid. */
(function () {
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) { return; }
    var containers = document.querySelectorAll('[data-badge-tiles]');
    for (var i = 0; i < containers.length; i++) {
      var map;
      try { map = JSON.parse(containers[i].getAttribute('data-badge-map')); } catch (e) { continue; }
      var handles = map[String(variant.id)];
      if (!handles) { continue; }
      var tiles = containers[i].querySelectorAll('.sinob_badges_design_inner');
      for (var j = 0; j < tiles.length; j++) {
        tiles[j].style.display = handles.indexOf(tiles[j].getAttribute('data-badgename')) > -1 ? 'flex' : 'none';
      }
    }
  }, true);
})();
